import ImageNewsTitleBackground from '../asserts/news/title-background.png'
import ImageNews1Img1 from '../asserts/news/news1img1.png'
import ImageNews1Img2 from '../asserts/news/news1img2.png'
import ImageNews2Img1 from '../asserts/news/news2img1.png'
import ImageNews2Img2 from '../asserts/news/news2img2.png'
import ImageNews2Img3 from '../asserts/news/news2img3.png'
import ImageNews2Img4 from '../asserts/news/news2img4.png'
import ImageNews2Img5 from '../asserts/news/news2img5.png'
import ImageNews2Img6 from '../asserts/news/news2img6.png'
import ImageNews2Img7 from '../asserts/news/news2img7.png'
import ImageNews3Img1 from '../asserts/news/news3img1.png'
import ImageNews3Img2 from '../asserts/news/news3img2.png'
import ImageNews3Img3 from '../asserts/news/news3img3.png'
import ImageNews4Img1 from '../asserts/news/news4img1.png'
import ImageNews4Img2 from '../asserts/news/news4img2.png'

const NEWSCONFIG = {
  title: { en: 'News Information', cn: '新闻资讯', background: ImageNewsTitleBackground },
  info: [
    {
      title: { en: '', cn: '济民制药：证券简称 6 月 4 日起变更为“济民医疗”' },
      time: '2021-06-01 13:13',
      content: [
        {
          type: 'paragraph',
          en: '',
          cn: '1、济民制药公告，经公司申请，并经上交所办理，公司证券简称自 6 月 4 日由 " 济民制药 " 变更为 " 济民医疗 "，公司证券全称及公司证券代码保持不变。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '2、公司全资子公司 LINEAR 公司位于西班牙巴塞罗那，主要研发及生产体外诊断产品及试剂，拥有临床化学诊断试剂、免疫学诊断试剂、血液检测试剂、快速诊断试剂、酶联免疫诊断试剂、实验室仪器及体外诊断医疗产品等七大类产品线，两大核心产品 FOB 粪便潜血自动免疫测试仪和幽门螺旋杆菌检测试剂盒，并于 2020 年上半年推出了新冠病毒检测试剂盒。3、公司全资子公司聚民生物位于上海市奉贤区，主要研发及生产安全注射器、安全注射针、安全采血针、无菌注射器、胰岛素注射器、输液器等产品。'
        },
        { type: 'image', src: ImageNews1Img1 },
        { type: 'image', src: ImageNews1Img2 }
      ]
    },
    {
      title: { en: '', cn: '奉贤南桥体育中心：小小注射器，筑牢疫情防控屏障' },
      time: '2021-05-28 18:12',
      content: [
        {
          type: 'paragraph',
          en: '',
          cn: '为做好新冠疫情常态化防控，更好保护人民群众身体健康，根据国家部署，按照“知情同意、自愿免费”的原则，上海市启动18岁及以上人群新冠疫苗登记预约接种工作。上海市18岁及以上身体健康、无禁忌症的社区居民，可通过社区整建制登记预约并至至指定社区接种点接种。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '今天我们来到了奉贤规模最大的体育健身运动中心也是我们最大的接种点中心——————奉贤体育中心'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '来到接种点入口，便是人山人海的接种者。'
        },
        { type: 'image', src: ImageNews2Img1 },
        { type: 'image', src: ImageNews2Img2 },
        { type: 'image', src: ImageNews2Img3 },
        {
          type: 'paragraph',
          en: '',
          cn: '来到接种点，可以看到该接种点使用的是中国双鸽集团聚民生物的注射器。为保质保量完成疫苗注射器的供应任务，聚民生物增加了4条生产线和一线操作工330人，员工轮流倒班，设备24小时不停机，生产任务由去年的5亿支增加到今年的10亿支。'
        },
        { type: 'image', src: ImageNews2Img4 },
        { type: 'image', src: ImageNews2Img5 },
        { type: 'image', src: ImageNews2Img6 },
        {
          type: 'paragraph',
          en: '',
          cn: '哪有什么岁月静好，而是有人在替我们负重前行。就像这群天生勇敢的抗疫战士，他们她们是前线医护人员，是社区防疫基层工作者。在疫情，他们她们勇敢献身，全情投入。致敬抗疫前线的勇敢女战士!一起祈福疫情战役早日结束!'
        },
        { type: 'image', src: ImageNews2Img7 }
      ]
    },
    {
      title: { en: '', cn: '安全注射器已获批文' },
      time: '2021-04-06 11:40',
      content: [
        {
          type: 'paragraph',
          en: '',
          cn: '2021年4月6日，我司安全注射器产品已经获得NMPA的注册证，注册证号：国械注准20213140196。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '本产品已在美国、欧洲等发达国家广泛使用，并在这次新冠病毒的抗疫中，为疫苗接种提供了最佳的选择。'
        },
        {
          type: 'subtitle',
          en: '',
          cn: '临床注射技术现状与趋势'
        },
        { type: 'image', src: ImageNews3Img1 },
        {
          type: 'subtitle',
          en: '',
          cn: '注射器消耗量 '
        },
        {
          type: 'paragraph',
          en: '',
          cn: '我国医疗部门年消耗一次性使用无菌注射器150亿支，每年至少进行160亿次注射操作。'
        },
        {
          type: 'subtitle',
          en: '',
          cn: '护士人数'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '2019年末卫生人员总数中，注册护士444.5万人。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '医务工作者在医院中面临各种锐器刺伤，中国，每年大约有230万例刺伤发生。健康的医务工作者患传染病者80%-90%是由针刺伤所致。'
        },
        {
          type: 'subtitle',
          en: '',
          cn: '医务人员所面对的挑战'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '艾滋病感染人数超过100万人、性病每年递增15%、结核病患者约500万人（世界第二位）、乙型肝炎病毒感染率达我国人口的15%。'
        },
        { type: 'image', src: ImageNews3Img2 },
        {
          type: 'paragraph',
          en: '',
          cn: '世界卫生组织定义，安全注射包含三个方面：对接受注射者无不良损害；对实施注射人员不存在危险；注射的废弃物对其他人不构成威胁。'
        },
        {
          type: 'subtitle',
          en: '',
          cn: '安全注射器优势分析'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '安全：注射完毕后，针尖自动回缩，防止针尖刺伤，阻断感染传播、保障患者及医务人员安全。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '操作简单，较少工作量：与普通注射操作规范一直，可单手使用，操作简单易学。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '瞬间拔针，缓解疼痛：针尖瞬间拔出，大大减轻了疼痛感；弹簧、摩擦环等独特的设计结构；采用了日本的磨针技术；护士无需快速拔针。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '减少医疗垃圾：100支废弃的注射器：a普通注射器，体积约0.05立方；b安全注射器，体积约0.03立方，中国注射器年消耗量约120亿支，若全都采用安全注射器，可减少2.4亿立方的医疗垃圾。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '专利技术：与美国RTI合作，专利号：6572584、2015203041041、2011103013885。'
        },
        { type: 'image', src: ImageNews3Img3 },
        {
          type: 'subtitle',
          en: '',
          cn: '“针”安全，才是真安全！'
        },
      ]
    },
    {
      title: { en: '', cn: '接种新冠疫苗 构筑免疫屏障' },
      time: '2021-02-12 10:36',
      content: [
        {
          type: 'paragraph',
          en: '',
          cn: '于2021年2月12日随着疫苗接种工作有序推进，疫苗注射器等相关产品需求量上升，上海聚民生物公司新冠疫苗安全注射针和注射器的生产任务由去年的5亿支增加到今年的10亿支。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '4月2日，在聚民生物科技有限公司，眼前的场面甚为壮观。为保质保量完成生产任务，今年公司增加了4条生产线和一线操作工330人，员工轮流倒班，设备24小时不停机。公司总经理别涌介绍说：“我们全公司上下700多名员工，全都在加班加点”'
        },
        { type: 'video', src: 'http://vd3.bdstatic.com/mda-mbbkk9awizm60s5e/v1-cae/mda-mbbkk9awizm60s5e.mp4' },
        {
          type: 'paragraph',
          en: '',
          cn: '灯检工解文菊的任务是流水线上质量把控最后一关，在灯光照射下，凭肉眼查看产品质量，她每天值班12小时，大约每秒钟要过目3支注射器。上海聚民生物科技有限公司职工解文菊：最后剩下来的是机器检测不了的，靠我这一道把关，一天的话有十五六万（支），我每天多加班，多生产一支注射器，那么对国家也有一点小小的贡献吧。'
        },
        { type: 'image', src: ImageNews4Img1 },
        {
          type: 'subtitle',
          en: '',
          cn: '聚民生物科技有限公司增线扩产新闻观看请点击下方图片'
        },
        { type: 'image', src: ImageNews4Img2, link: 'https://tv.cctv.com/2021/04/02/VIDEqJft4kzjtdF9XtPf7j5v210402.shtml' },
        {
          type: 'paragraph',
          en: '',
          cn: '目前，我司安全注射器产品已经获得NMPA的注册证，注册证号：国械注准20213140196。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '本产品已在美国、欧洲等发达国家广泛使用，并在这次新冠病毒的抗疫中，为疫苗接种提供了最佳的选择。'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '本产品完全采用美国的标准，与普通注射器或者其它自毁注射器相比，具有以下优势：'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '1. 注射完毕，针尖自动回缩，针尖不外露，保护医务工作者以及患者的安全，从根本上彻底解决了被刺伤的风险；'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '1. 注射完毕，针尖自动回缩，针尖不外露，保护医务工作者以及患者的安全，从根本上彻底解决了被刺伤的风险；'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '2. 安全注射：本产品注射完毕，针尖自动回缩，无需上述盖帽过程，减轻医务工作者劳动强度，节省大量时间；'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '3. 针尖瞬间拔出，护士无需快速拔针（针尖拔出的速度为普通拔出的6倍）；'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '4. 采用了日本的磨针技术，大大减轻了疼痛；'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '5. 无天然乳胶；'
        },
        {
          type: 'paragraph',
          en: '',
          cn: '6. 本产品针尖回缩至注射器内部，大大减少了医疗垃圾。'
        },
      ]
    }
  ]
}

export default NEWSCONFIG